var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$store.state.color + ' hamburger-menu-wrap'},[_c('div',{class:(_vm.open ? 'open ' : '') + 'hamburger-menu'},[_c('div',{staticClass:"hamburger-menu__line"}),_vm._v(" "),_c('div',{staticClass:"hamburger-menu__line"}),_vm._v(" "),_c('div',{staticClass:"hamburger-menu__line"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8949a938","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hamburger/index.vue
// module id = null
// module chunks = 